<div class="artists">
    <div class="heading">List of Artists:</div>
    <div class="list-container scrollbars">
        <ul class="list">
            <li class="item" *ngFor="let proj of projects">
                <artist-preview [project]="proj" [modalCloseUrl]="'/map/artists'"></artist-preview>
                <!-- <a [href]="'/map/artist/' + proj.project_slug" class="artist" (click)="clickArtist($event, proj)">
                    <span class="image" [style]="proj.project_image ? ('background-image: url(\'' + proj.project_image + '\')') : ''"></span>
                    <span class="text">
                        <span class="description" [innerHTML]="proj.project_name"></span>
                        <span class="name" [innerHTML]="proj.artist_name"></span>
                        <span class="more">Learn More</span>
                    </span>
                </a> -->
            </li>
        </ul>
    </div>
</div>
